import { unstable_createStore as createStore } from 'jotai'
import { Credentials } from '../utilities/atoms'
import { TranspaisIDToken } from '../utilities/atoms'

// Crea una store global (solo una vez)
const globalStore = createStore()

// Función normal (no hook) para obtener el pin
export const getGlobalPin = () => {
  const credentials = globalStore.get(Credentials)
  return credentials?.pin || ''
};

export const getGlobalTranspaisIDToken = () => {
    const transpaisToken = globalStore.get(TranspaisIDToken)
    return transpaisToken || ''
}

/** Alinea el store usado por `transpais.js` (axios) con el valor del átomo en React. */
export const syncServiceTranspaisIdToken = (value) => {
    globalStore.set(TranspaisIDToken, typeof value === 'string' ? value : '')
}